import { render, staticRenderFns } from "./TextWithButton.vue?vue&type=template&id=18123ccd&scoped=true&"
import script from "./TextWithButton.vue?vue&type=script&lang=ts&"
export * from "./TextWithButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18123ccd",
  null
  
)

export default component.exports